import script from "./ReadingProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadingProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./ReadingProgressBar.vue?vue&type=style&index=0&id=6254aa33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6254aa33"]])

export default __exports__